'use client';

import React, { createContext, useContext } from 'react';
import {
  usePerformanceProfile,
  type PerformanceProfile,
} from '@/hooks/usePerformanceProfile';

const defaultProfile: PerformanceProfile = {
  reducedMotion: false,
  isMobile: true,
  isCoarsePointer: false,
  saveData: false,
  isLite: true,
  isRich: false,
  loop: 0,
  enableParallax: false,
  enableInfinite: false,
  metricIntervalMs: 5200,
  titleIntervalMs: 3200,
};

const PerformanceContext = createContext<PerformanceProfile>(defaultProfile);

export function PerformanceProvider({ children }: { children: React.ReactNode }) {
  const profile = usePerformanceProfile();
  return (
    <PerformanceContext.Provider value={profile}>{children}</PerformanceContext.Provider>
  );
}

export function usePerf() {
  return useContext(PerformanceContext);
}
